import * as CategoryActionTypes from '../constants/category/ActionTypes';

export const updateCateghoryInfo = (categoryId, categoryInfo, applyImage, applyDescription) => ({
  type: CategoryActionTypes.UPDATE_CATEGORY_INFO,
  categoryId, categoryInfo, applyImage, applyDescription
});

export const setEditingCategoryInfo = (category) => ({
  type: CategoryActionTypes.SET_EDITING_CATEGORY_INFO,
  category
});

export const startEditMode = (categoryId) => ({
    type: CategoryActionTypes.START_EDIT_MODE,
    categoryId
});

export const endEditMode = (categoryId) => ({
    type: CategoryActionTypes.END_EDIT_MODE,
    categoryId
});

export const prependAtRootCategory = () => ({
    type:CategoryActionTypes.PREPEND_AT_ROOT_CATEGORY
});

export const appendAtRootCategory = () => ({
    type:CategoryActionTypes.APPEND_AT_ROOT_CATEGORY
});

export const appendCategory = (category) => ({
    type: CategoryActionTypes.APPEND_CATEGORY,
    category
});

export const removeCategory = (categoryId) => ({
    type: CategoryActionTypes.REMOVE_CATEGORY,
    categoryId
});

export const initCategories = (data) => ({
	type: CategoryActionTypes.INIT_CATEGORY,
	data
});

export const openSubCategory = (index) => ({
    type : CategoryActionTypes.OPEN_SUB_CATEGORY,
    index
});

export const closeSubCategory = (index) => ({
    type : CategoryActionTypes.CLOSE_SUB_CATEGORY,
    index
});

export const openAllSubCategory = () => ({
    type : CategoryActionTypes.OPEN_ALL_SUB_CATEGORY
});

export const closeAllSubCategory = () => ({
    type : CategoryActionTypes.CLOSE_ALL_SUB_CATEGORY
});

export const updateCategoryName = (categoryId, name, needBulkUpdate) => ({
    type : CategoryActionTypes.UPDATE_CATEGORY_NAME,
    categoryId,
    name,
    needBulkUpdate
});

export const updateCategoryViewChannel = (categoryId, viewChannel, needBulkUpdate) => ({
    type : CategoryActionTypes.UPDATE_CATEGORY_VIEW_CHANNEL,
    categoryId,
    viewChannel,
    needBulkUpdate
});

export const moveCategory = (category, to, placement) => ({
    type : CategoryActionTypes.MOVE_CATEGORY,
    category,
    to,
    placement
});

export const updateRootCategoryLabel = (rootLabel) => ({
    type : CategoryActionTypes.UPDATE_ROOT_CATEGORY_LABEL,
    rootLabel
});


export const updateCategoryTree = (categoryTree) => ({
    type : CategoryActionTypes.UPDATE_CATEGORY_TREE,
    categoryTree
});

export const updateCategoryVisibility = (categoryId, visibility, needBulkUpdate) => ({
  type : CategoryActionTypes.UPDATE_CATEGORY_VISIBILITY,
  categoryId,
  visibility,
  needBulkUpdate
});
